import * as type from './dailyQuizActionTypes';

export const setInitialTime = (time) => ({
  // In seconds
  type: type.SET_INITIAL_TIME,
  time,
});

export const startTimer = (timer) => ({
  type: type.START_TIMER,
  timer,
});

export const setDailyTimeOut = (value) => ({
  type: type.SET_DAILY_TIMEOUT,
  value,
});

export const setQualDailyQuizDailyTimeOut = (value) => ({
  type: type.SET_QUAL_DAILY_QUIZ_DAILY_TIMEOUT,
  value,
});

export const stopTimer = () => ({
  type: type.STOP_TIMER,
});

export const setPointsCorrectAnswer = () => ({
  type: type.SET_POINTS_CORRECT_ANSWER,
});

export const setPointsAccuracy = () => ({
  type: type.SET_POINTS_ACCURACY,
});

export const setPointsTime = () => ({
  type: type.SET_POINTS_TIME,
});

export const setCorrectAnswerCounterDaily = () => ({
  type: type.SET_CORRECT_ANSWER_COUNTER_DAILY,
});

export const setAnsweredQuestionDaily = () => ({
  type: type.SET_ANSWERED_QUESTIONS,
});

export const setRemainingQuestionDaily = () => ({
  type: type.SET_REMAINING_QUESTIONS,
});

export const getQuestionsDailyQuiz = () => ({
  type: type.GET_DAILY_QUIZ_QUESTIONS,
});

export const setQuestionsDailyQuiz = (questions) => ({
  type: type.SET_DAILY_QUIZ_QUESTIONS,
  questions,
});

export const sendDailyQuizAnswer = (answer) => ({
  type: type.SEND_DAILY_QUIZ_ANSWER,
  answer,
});

export const updateTimer = () => ({
  type: type.UPDATE_TIMER,
});

export const getResultsDailyQuiz = () => ({
  type: type.GET_RESULTS_DAILY_QUIZ,
});

export const setResultsDailyQuiz = (results) => ({
  type: type.SET_RESULTS_DAILY_QUIZ,
  results,
});

// CHECK STATUS
export const checkDailyQuizStatus = () => ({
  type: type.CHECK_DAILY_QUIZ_STATUS,
});

export const setCheckDailyQuizStatusWaiting = (value) => ({
  type: type.SET_CHECK_DAILY_QUIZ_STATUS_WAITING,
  value,
});

export const setIsLoadingQualDailyQuizStatus = (value) => ({
  type: type.SET_IS_LOADING_QUAL_DAILY_QUIZ_STATUS,
  value,
});

export const setIsQualDailyQuizRunning = (value) => ({
  type: type.SET_IS_QUAL_DAILY_QUIZ_RUNNING,
  value,
});

export const checkQualDailyQuizStatus = () => ({
  type: type.CHECK_QUAL_DAILY_QUIZ_STATUS,
});

// LOAD DAILY QUIZ
export const loadDailyQuiz = (id = null, isRetake = false) => ({
  type: type.LOAD_DAILY_QUIZ,
  id,
  isRetake,
});

export const loadQualDailyQuiz = (id = null, isRetake = false) => ({
  type: type.LOAD_QUAL_DAILY_QUIZ,
  id,
  isRetake,
});

export const setLoadDailyQuizWaiting = (value) => ({
  type: type.SET_LOAD_DAILY_QUIZ_WAITING,
  value,
});

// UPDATE DAILY QUIZ
export const updateDailyQuiz = (
  dailyQuizId,
  dataResultsDetailed,
  isRetake,
) => ({
  type: type.UPDATE_DAYILY_QUIZ,
  dailyQuizId,
  dataResultsDetailed,
  isRetake,
});

export const updateQualDailyQuiz = (
  qualDailyQuizId,
  dataResultsDetailed,
  isRetake,
) => ({
  type: type.UPDATE_QUAL_DAILY_QUIZ,
  qualDailyQuizId,
  dataResultsDetailed,
  isRetake,
});

// SUBMIT DAILY QUIZ
export const submitDailyQuiz = (
  dailyQuizId,
  dataResultsDetailed,
  isRetake,
) => ({
  type: type.SUBMIT_DAILY_QUIZ,
  dailyQuizId,
  dataResultsDetailed,
  isRetake,
});

export const submitQualDailyQuiz = (
  qualDailyQuizId,
  dataResultsDetailed,
  isRetake,
) => ({
  type: type.SUBMIT_QUAL_DAILY_QUIZ,
  qualDailyQuizId,
  dataResultsDetailed,
  isRetake,
});

export const setSubmitDailyQuizWaiting = (value) => ({
  type: type.SET_SUBMIT_DAILY_QUIZ_WAITING,
  value,
});

export const setIsLoadingSubmitQualDailyQuiz = (value) => ({
  type: type.SET_IS_LOADING_SUBMIT_QUAL_DAILY_QUIZ,
  value,
});

export const setIsSubmitQualDailyQuizSuccessful = (value) => ({
  type: type.SET_IS_SUBMIT_QUAL_DAILY_QUIZ_SUCCESSFUL,
  value,
});

export const setSubmitDailyQuizSuccess = (value) => ({
  type: type.SET_SUBMIT_DAILY_QUIZ_SUCCESS,
  value,
});

// SETTERS
export const setNextQuizIn = (value) => ({
  type: type.SET_NEXT_QUIZ_IN,
  value,
});

export const setNextQualDailyQuizIn = (value) => ({
  type: type.SET_NEXT_QUAL_DAILY_QUIZ_IN,
  value,
});

export const setQualDailyQuizProgress = (value) => ({
  type: type.SET_QUAL_DAILY_QUIZ_PROGRESS,
  value,
});

export const setDailyQuizRunning = (value) => ({
  type: type.SET_DAILY_QUIZ_RUNNING,
  value,
});

export const setDailyQuiz = (quiz) => ({
  type: type.SET_DAILY_QUIZ,
  quiz,
});

export const setDailyQuizRetake = (quiz) => ({
  type: type.SET_DAILY_QUIZ_RETAKE,
  quiz,
});

export const setQualDailyQuiz = (quiz) => ({
  type: type.SET_QUAL_DAILY_QUIZ,
  quiz,
});

export const setQualDailyQuizRetake = (quiz) => ({
  type: type.SET_QUAL_DAILY_QUIZ_RETAKE,
  quiz,
});

export const setProgress = (progress) => ({
  type: type.SET_PROGRESS,
  progress,
});
